export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-book-318e57c87eb6b87620c39f1490402a91.svg";